export interface ParcoursFormationManagmentState {
  searchTerm: string;
  pageIndex: number;
  pageSize: number;
}

export const defaultParcoursFormationManagmentState: ParcoursFormationManagmentState = {
  searchTerm: '',
  pageIndex: 0,
  pageSize: 10
};

export function validateParcoursFormationManagmentState(state: any): ParcoursFormationManagmentState {
  if (!state || typeof state !== 'object') {
    return { ...defaultParcoursFormationManagmentState };
  }

  return {
    searchTerm: typeof state.searchTerm === 'string' ? state.searchTerm : '',
    pageIndex: typeof state.pageIndex === 'number' && state.pageIndex >= 0 ? state.pageIndex : 0,
    pageSize: typeof state.pageSize === 'number' && state.pageSize > 0 ? state.pageSize : 10
  };
}